/* eslint-disable default-case */
/* eslint-disable camelcase */
import React from 'react';
import { styled } from '@mui/material/styles';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
// Material UI icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PATHS from 'lib/navigation/paths';
import GIcon from 'views/common/components/Logical/Layout/Footer/NeedHelp/GIcon';
import { useTranslation } from 'next-i18next';
import { FAQS_TYPES_PATHS } from 'lib/utils/CONSTANTS';

const PREFIX = 'TopFaqs';

const classes = {
  root: `${PREFIX}-root`,
  rootBorder: `${PREFIX}-rootBorder`,
  header: `${PREFIX}-header`,
  rotate: `${PREFIX}-rotate`,
  title: `${PREFIX}-title`,
  expandIcon: `${PREFIX}-expandIcon`,
  list: `${PREFIX}-list`,
  item: `${PREFIX}-item`,
  link: `${PREFIX}-link`,
  gIcon: `${PREFIX}-gIcon`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.fogWhite,
  },

  [`&.${classes.rootBorder}`]: {
    borderRadius: ' 0 0 15px 15px',
  },

  [`& .${classes.header}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    [`& .${classes.title}`]: {
      color: theme.palette.common.fogWhite,
      textTransform: 'uppercase',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      fontWeight: 500,
      cursor: 'pointer',
      flexGrow: 1,
      [`& .${classes.expandIcon}`]: {
        fontSize: '1.1rem',
        margin: `0 ${theme.typography.pxToRem(5)}`,
        color: theme.palette.common.fogWhite,
        transition: 'transform 0.2s ease',
      },
    },
  },

  [`& .${classes.rotate}`]: {
    transform: 'rotate(-180deg)',
  },

  [`& .${classes.title}`]: {},
  [`& .${classes.expandIcon}`]: {},

  [`& .${classes.list}`]: {
    paddingBottom: theme.spacing(2),
  },

  [`& .${classes.item}`]: {
    padding: '0 !important',
    '& .MuiListItemText-root': {
      marginTop: 0,
      marginBottom: 0,
    },
  },

  [`& .${classes.link}`]: {
    padding: theme.spacing(1.4, 2.5),
    display: 'flex',
    color: theme.palette.common.fogWhite,
    fontSize: '0.875rem',
    fontWeight: 500,
    [`& .${classes.gIcon}`]: {
      marginRight: '1rem',
      color: theme.palette.grey[300],
    },
  },
  '& .TFGoFaq': {
    color: theme.palette.common.black,
  },
  [`& .${classes.gIcon}`]: {},
}));

const TopFaqs = ({ faq_items, isContactUsPage }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(false);

  const returnPath = (type_identifier) => {
    let path = PATHS.faqs.withSlug(FAQS_TYPES_PATHS.rental).url;
    switch (type_identifier) {
      case 'rental':
        path = PATHS.faqs.withSlug(FAQS_TYPES_PATHS.rental).url;
        break;
      case 'self_drive':
        path = PATHS.faqs.withSlug(FAQS_TYPES_PATHS.self_drive).url;
        break;
      case 'guided':
        path = PATHS.faqs.withSlug(FAQS_TYPES_PATHS.guided).url;
        break;
      case 'membership':
        path = PATHS.faqs.withSlug(FAQS_TYPES_PATHS.membership).url;
        break;
    }
    return path;
  };

  return (
    <Root
      className={`${classes.root} ${isContactUsPage && classes.rootBorder}`}>
      <div className={classes.header}>
        <Typography
          variant="body2"
          className={classes.title}
          onClick={() => setExpanded(!expanded)}>
          {t('common_layout_v2:faqs.top_faqs')}
          <ExpandMoreIcon
            className={`${classes.expandIcon} ${
              expanded ? classes.rotate : ''
            }`}
          />
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={NavigatorLink}
          className="TFGoFaq"
          target="_blank"
          href={PATHS.faqs.withSlug(FAQS_TYPES_PATHS.rental)}>
          {t('common_layout_v2:faqs.go_to_faqs')}
        </Button>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider />
        <List disablePadding className={classes.list}>
          {faq_items?.map((item) => (
            <React.Fragment key={item.text}>
              <ListItem button className={classes.item}>
                <ListItemText
                  primary={(
                    <NavigatorLink
                      className={classes.link}
                      href={returnPath(item.type_identifier)}
                      color="textSecondary">
                      <GIcon className={classes.gIcon} />
                      {item.question}
                    </NavigatorLink>
                  )}
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </Collapse>
    </Root>
  );
};

export default TopFaqs;
